/**
 * @generated SignedSource<<d86b8abe88d9aca0186e6319228c96d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "participativeModuleSlug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "participativeModuleSlug",
    "variableName": "participativeModuleSlug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contributionsCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconClass",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryColor",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryContrastColor",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reactionsCount",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Theme",
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContributionsDatavizListRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "participativeModule",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContributionsDatavizList_participativeModule"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContributionsDatavizListRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "participativeModule",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ParticipativeModuleAuthorizations",
                "kind": "LinkedField",
                "name": "authorizations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contributionsDisplayAuthorized",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "visualization",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enableListViewOnFirstPage",
                        "storageKey": null
                      }
                    ],
                    "type": "ContributionsDataviz",
                    "abstractKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "themes",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v3/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v4/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Theme",
                        "kind": "LinkedField",
                        "name": "children",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v3/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v4/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "ParticipativeModule",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "54b1d541937d8af247eabeec67470c76",
    "id": null,
    "metadata": {},
    "name": "ContributionsDatavizListRouteQuery",
    "operationKind": "query",
    "text": "query ContributionsDatavizListRouteQuery(\n  $participativeModuleSlug: ID!\n) {\n  participativeModule(participativeModuleSlug: $participativeModuleSlug) {\n    __typename\n    ...ContributionsDatavizList_participativeModule\n    id\n  }\n}\n\nfragment ContributionsDatavizListItemsTheme_participativeModule on ParticipativeModule {\n  slug\n}\n\nfragment ContributionsDatavizListItemsTheme_theme on Theme {\n  id\n  slug\n  name\n  iconClass\n  primaryColor\n  primaryContrastColor\n  description\n  contributionsCount\n  reactionsCount\n  ...ContributionsDatavizThemeMeasures_theme\n  parent {\n    name\n    id\n  }\n  children {\n    id\n  }\n}\n\nfragment ContributionsDatavizListItems_participativeModule on ParticipativeModule {\n  themes {\n    id\n    name\n    description\n    children {\n      id\n      ...ContributionsDatavizListItemsTheme_theme\n    }\n    ...ContributionsDatavizListItemsTheme_theme\n    ...ContributionsDatavizThemesNavigationTheme_theme\n  }\n  ...ContributionsDatavizListItemsTheme_participativeModule\n  ...ContributionsDatavizThemesNavigationTheme_participativeModule\n}\n\nfragment ContributionsDatavizList_participativeModule on ParticipativeModule {\n  ...ContributionsDatavizRootLayout_participativeModule\n  ...ContributionsDatavizListItems_participativeModule\n}\n\nfragment ContributionsDatavizMainContainerHeader_participativeModule on ParticipativeModule {\n  ...ContributionsDatavizViewModeSwitch_participativeModule\n}\n\nfragment ContributionsDatavizRootLayout_participativeModule on ParticipativeModule {\n  title\n  slug\n  contributionsCount\n  authorizations {\n    contributionsDisplayAuthorized\n  }\n  ...ContributionsDatavizTabs_participativeModule\n  ...ContributionsDatavizThemesNavigation_participativeModule\n  ...ContributionsDatavizMainContainerHeader_participativeModule\n}\n\nfragment ContributionsDatavizTabs_participativeModule on ParticipativeModule {\n  slug\n  visualization {\n    __typename\n    ... on ContributionsDataviz {\n      enableListViewOnFirstPage\n    }\n    id\n  }\n}\n\nfragment ContributionsDatavizThemeMeasures_theme on Theme {\n  contributionsCount\n  reactionsCount\n}\n\nfragment ContributionsDatavizThemesNavigationTheme_participativeModule on ParticipativeModule {\n  slug\n}\n\nfragment ContributionsDatavizThemesNavigationTheme_theme on Theme {\n  description\n  children {\n    id\n    slug\n    name\n    iconClass\n    primaryColor\n    primaryContrastColor\n  }\n  id\n  slug\n  name\n  iconClass\n  primaryColor\n  primaryContrastColor\n  ...ContributionsDatavizThemeMeasures_theme\n}\n\nfragment ContributionsDatavizThemesNavigation_participativeModule on ParticipativeModule {\n  ...ContributionsDatavizThemesNavigationTheme_participativeModule\n  themes {\n    id\n    children {\n      __typename\n      id\n    }\n    ...ContributionsDatavizThemesNavigationTheme_theme\n  }\n}\n\nfragment ContributionsDatavizViewModeSwitch_participativeModule on ParticipativeModule {\n  slug\n}\n"
  }
};
})();

node.hash = "681d550ddc2476188173a76162ce3f7e";

module.exports = node;
